
import React, { useEffect, useRef, useState } from "react";
import { Brain, Compass, Sparkles } from "lucide-react";

const TrustElementsHome = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  const items = [
    { icon: Brain, title: "Neurowissenschaftlich fundiert", text: "Erkenntnisse der Neuroplastizität für nachhaltige finanzielle Entscheidungsmuster" },
    { icon: Compass, title: "Zielorientierte Begleitung", text: "Maßgeschneiderte Lösungen statt standardisierter Beratung" },
    { icon: Sparkles, title: "Transparente Zusammenarbeit", text: "Keine versteckten Kosten oder Verkaufsinteressen" },
  ];

  return (
    <div ref={containerRef} className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {items.map((item, i) => (
        <div
          key={i}
          className={`flex flex-col p-6 bg-joerg-50 rounded-2xl shadow-sm hover:shadow-md transition-all duration-500 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
          style={{ transitionDelay: isVisible ? `${i * 150}ms` : "0ms" }}
        >
          <div className="flex flex-col items-center mb-3">
            <div className="bg-white/50 p-3 rounded-full mb-3 flex items-center justify-center">
              <item.icon className="h-6 w-6 text-primary" />
            </div>
            <h3 className="text-lg font-semibold mb-3 text-center">{item.title}</h3>
          </div>
          <p className="text-joerg-600 text-left">{item.text}</p>
        </div>
      ))}
    </div>
  );
};

export default TrustElementsHome;
